/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type ZerogInternalTrxNestedInfo = {
    BNO: string;
    PTRXHA: string;
    STP: ZerogInternalTrxNestedInfo.STP;
    TRCTP: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    AMT: string;
    GL: string;
    VAL: string;
    AG: string;
    UT: number;
    SEQNO: number;
    TRCLV: number;
};

export namespace ZerogInternalTrxNestedInfo {

    export enum STP {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

